import React from 'react'

import { Avatar } from 'antd';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { removeFalsyKeys, calcIndexByOrder } from 'utils/common';
import { useCustomSearchParams } from 'hooks/useCustomSearchParams';
import { PATH_NAME_ACTION } from 'constants/routes';
import { formatTime } from 'utils/timeUtils';

import { useMenus } from 'api/menuApi';

import { StyledActions, StyledButton } from 'styles/overrides';
import { Table } from 'components/table';
import { Publish } from 'components/common';

import { MenuFilterSearch } from '../MenuFilterSearch';

export default function MenuTable () {
  const intl = useIntl();
  const [search, setSearch] = useCustomSearchParams();

  const { data, isLoading } = useMenus({ params: search })

  const columns = [
    {
      title: intl.formatMessage({ id: 'common.table.no' }),
      render: (text, record, index) => {
        return calcIndexByOrder({
          index,
          page: search.page,
          limit: search.page_size,
        });
      },
    },
    {
      title: intl.formatMessage({ id: 'common.table.avatar' }),
      dataIndex: 'file',
      render: (value) => <Avatar src={value?.path} size={32} />,
    },
    {
      title: intl.formatMessage({ id: 'common.table.published' }),
      dataIndex: 'status',
      render: (value) => <Publish published={value} />,
    },
    {
      title: intl.formatMessage({ id: 'common.table.createdAt' }),
      dataIndex: 'created_at',
      render: (value) => formatTime(value),
    },
    {
      render: ({ id }) => (
        <Link to={`${id}`}>
          <StyledButton type="primary">
            {intl.formatMessage({ id: 'common.btn.seeDetails' })}
          </StyledButton>
        </Link>
      ),
    },
  ];

  const handleChangeTable = ({ current: page, pageSize: limit }) => {
    setSearch(removeFalsyKeys({ ...search, page, page_size: limit }));
  };

  return (
    <>
      <MenuFilterSearch
        onSubmit={(values) => setSearch(values)}
        initialValues={search}
      />
      <StyledActions size={24}>
        <Link to={PATH_NAME_ACTION.CREATE}>
          <StyledButton type="primary">
            {intl.formatMessage({ id: 'common.btn.addNew' })}
          </StyledButton>
        </Link>

        {/* <StyledButton
          onClick={handleDelete}
          disabled={selectedRowKeys.length === 0}
        >
          {intl.formatMessage({ id: 'common.btn.delete' })}
        </StyledButton> */}
      </StyledActions>
      <Table
        rowKey="id"
        // rowSelection={{
        //   selectedRowKeys,
        //   onChange: (newSelectedRowKeys) => {
        //     setSelectedRowKeys(newSelectedRowKeys);
        //   },
        //   preserveSelectedRowKeys: true,
        // }}
        columns={columns}
        dataSource={data?.data || []}
        loading={isLoading}
        pagination={false}
        onChange={handleChangeTable}
      />
    </>
  )
}